import { render } from "./QuickpaySettingsBlockPreferencesLoader.vue?vue&type=template&id=7acbdbc4&scoped=true"
const script = {}

import "./QuickpaySettingsBlockPreferencesLoader.vue?vue&type=style&index=0&id=7acbdbc4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7acbdbc4"]])

export default __exports__